import { LinkSize } from '@dreryk/react-components';

import { AppointmentNoteManagementModalOpener } from '~libs.desktop.shared.appointment';

import { StyledLink } from './AppointmentNoteModifierLink.styled';
import { getLinkPropsConfiguration } from './AppointmentNoteModifierLink.utils';

type AppointmentNoteModifierLinkProps = {
   readonly appointmentId: number;
   readonly appointmentNote?: string;
   readonly onAppointmentNoteUpdated: VoidFunction;
};

export const AppointmentNoteModifierLink = (props: AppointmentNoteModifierLinkProps): JSX.Element => {
   return (
      <AppointmentNoteManagementModalOpener
         appointmentId={props.appointmentId}
         appointmentNote={props.appointmentNote}
         onAppointmentNoteUpdated={props.onAppointmentNoteUpdated}
      >
         {({ openModal }) => (
            <StyledLink
               onClick={openModal}
               testId={'noteManagement'}
               size={LinkSize.NORMAL}
               {...getLinkPropsConfiguration(props.appointmentNote)}
            />
         )}
      </AppointmentNoteManagementModalOpener>
   );
};
